import request from '@/utils/request';

/**
 * 获取作品角色列表
 */
export function listRoles(projectId) {
  return request({
    url: `/front/role/list/${projectId}`,
    method: 'get'
  });
}

/**
 * 获取角色详情
 */
export function getRole(id) {
  return request({
    url: `/front/role/${id}`,
    method: 'get'
  });
}

/**
 * 新增角色
 * @param {object} data - { projectId, roleType, name, gender, age, trait, identity, bio }
 */
export function createRole(data) {
  return request({
    url: '/front/role',
    method: 'post',
    data
  });
}

/**
 * 更新角色
 */
export function updateRole(id, data) {
  return request({
    url: `/front/role/${id}`,
    method: 'put',
    data
  });
}

/**
 * 删除角色
 */
export function deleteRole(id) {
  return request({
    url: `/front/role/${id}`,
    method: 'delete'
  });
}
